<template>
  <div :style="{'width': imgWidth, 'top': top, 'left': left, 'right': right, 'bottom': bottom}"
       class="tree img-w">
    <svg viewBox="0 0 114 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M113.362 0H0V48H113.362V0Z" fill="#FFD939"/>
      <path d="M55.9876 0H54.1688V48H55.9876V0Z" fill="black"/>
      <path d="M113.362 23.062H0V24.937H113.362V23.062Z" fill="black"/>
      <path d="M62.5313 17.8684L61.2188 16.5371L55.0688 22.6871L48.9376 16.5371L47.6063 17.8684L53.7563 23.9996L47.6063 30.1309L48.9376 31.4621L55.0688 25.3309L61.2188 31.4621L62.5313 30.1309L56.4001 23.9996L62.5313 17.8684Z" fill="black"/>
    </svg>

  </div>
</template>

<script>
  export default {
    name: "Gift",
    props: {
      imgWidth: {
        default: '7rem'
      },
      top: {
        default: 'auto'
      },
      left: {
        default: 'auto'
      },
      right: {
        default: 'auto'
      },
      bottom: {
        default: 'auto'
      },
      color: {
        default: 'white'
      }
    },
  }
</script>

<style scoped lang="scss">
  .tree {
    position: absolute;
    z-index: 50;

    &.is-yellow {
      svg * {
        fill: $yellow;
      }
    }
    &.is-white {
      svg * {
        fill: white;
      }
    }
  }
</style>
